function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Sentry from "@sentry/ember";
import { isMedicUser, isPatientUser } from "wise-control-tower";
import { resetDatadogUser, setDatadogUser, submitDatadogMetrics } from "../utils/datadog";
import { initializeSentry, resetSentryUser, setSentrySpanAttributes, setSentryTags, setSentryUser } from "../utils/sentry";
export default class ControlTower {
  static initialize({
    environment,
    sentryOptions
  }) {
    ControlTower.environment = environment;
    initializeSentry(environment, sentryOptions);
  }
  static captureException(e) {
    Sentry.captureException(e);
  }
  static captureMessage(msg) {
    Sentry.captureMessage(msg);
  }
  static async resetUser() {
    resetSentryUser();
    await resetDatadogUser();
  }
  static async setUser(user) {
    ControlTower.currentUser = user;

    // whitelist the user attributes we want to send to Sentry and DD
    const {
      class: cls,
      id,
      uuid
    } = user;
    const baseAttrs = {
      id: `${cls}-${id}`,
      class: cls,
      uuid
    };
    let attrs;
    if (isMedicUser(user)) {
      attrs = {
        role: user.role,
        sees_all_centre_patients: user.sees_all_centre_patients?.toString(),
        is_super_user: user.is_super_user?.toString()
      };
    } else if (isPatientUser(user)) {
      attrs = {
        health_centre_id: user.health_centre_id?.toString()
      };
    }
    const usr = {
      ...baseAttrs,
      ...attrs
    };
    setSentryUser(usr);
    await setDatadogUser(usr);
  }
  static async submitMetrics(metrics) {
    if (!this.isMonitoringEnabled) return;
    const updatedMetrics = ControlTower.injectDefaultTags(metrics);
    await submitDatadogMetrics(updatedMetrics);
    setSentrySpanAttributes(updatedMetrics);
    setSentryTags(updatedMetrics);
  }
  static get isMonitoringEnabled() {
    return ControlTower.forceMonitoring || Boolean(this.environment) && !["test", "development", "dev"].includes(ControlTower.environment);
  }
  static injectDefaultTags(metrics) {
    return metrics.map(metric => {
      metric.tags = metric.tags || [];
      if (ControlTower.environment) {
        metric.tags.push(`env:${ControlTower.environment}`);
      }
      if (ControlTower.currentUser) {
        metric.tags.push(`user_type:${ControlTower.currentUser.class}`);
        metric.tags.push(`user_id:${ControlTower.currentUser.id}`);
      }
      return metric;
    });
  }
}
/** Will force the monitoring to send data no matter what is the current environment */
_defineProperty(ControlTower, "forceMonitoring", false);
_defineProperty(ControlTower, "environment", void 0);
_defineProperty(ControlTower, "currentUser", void 0);